module.exports = __webpack_public_path__ + "img/xx.ba3cf93a.png";